'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGNMENT_CLASSES = exports.ALIGNMENT_CLASSES = {
  start: '',
  baseline: 'private-checkbox--align-baseline',
  center: 'private-checkbox--align-center',
  end: 'private-checkbox--align-end'
};

var PADDING_OPTIONS = exports.PADDING_OPTIONS = {
  default: '',
  none: 'private-checkbox--flush'
};

var SIZE_OPTIONS = exports.SIZE_OPTIONS = {
  default: '',
  sm: 'private-checkbox--small'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/CheckboxConstants.js
// module id = 212
// module chunks = 177